export default {
  create: 'Criar Simulação de Orçamento',
  createFromScratch: 'Do zero',
  createLastYearFree: 'Último Ano, Livre',
  createLastYearFrozen: 'Último Ano, Fixo',
  createNextYearFree: 'Próximo Ano, Livre',
  chooseSubtitle: 'Comece com uma simulação em branco ou deixe um modelo preencher o período e o orçamento para você.',
  chooseFromScratchDescription: 'Defina você o período, o orçamento de referência e o modo de mix.',
  chooseLastYearFreeTitle: 'Ano Anterior, Mix Livre',
  chooseLastYearFreeDescription: 'Os últimos 12 meses de dados, com o otimizador escolhendo o melhor mix para cada orçamento.',
  chooseLastYearFrozenTitle: 'Ano Anterior, Mix Fixo',
  chooseLastYearFrozenDescription: 'Os últimos 12 meses de dados, com cada orçamento mantendo o mix histórico de canais desse período.',
  chooseNextYearFreeTitle: 'Próximo Ano, Mix Livre',
  chooseNextYearFreeDescription: 'O orçamento que o modelo propaga para o próximo ano, com o otimizador escolhendo o melhor mix para cada orçamento.',
  chooseTagStrategyCheck: 'Strategy Check',
  chooseTagForwardLooking: 'Forward Looking',
  createFlexibleDates: 'Datas Flexíveis',
  chooseFlexibleTitle: 'Datas Flexíveis',
  chooseTagFlexible: 'Flexível',
  flexibleSummaryActual: 'Investimento real',
  flexibleSummaryPropagation: 'Propagação de orçamento',
  flexibleSummaryEmpty: 'Sem dados, soma 0',
  flexibleMonths: '{count} mês | {count} meses',
  flexibleWeeks: '{count} semana | {count} semanas',
  flexibleHintActual: 'Há investimento real disponível até {date}.',
  flexibleHintPropagation: 'A propagação de orçamento cobre de {from} a {to}.',
  chooseFlexibleDescription: 'Escolha qualquer período: seu orçamento de referência e seu mix Fixo somam o investimento real onde o modelo o tem e a propagação de orçamento depois.',
  flexibleSummaryTotal: 'Orçamento de referência',
  flexibleHintMix: 'A simulação começa com mix Livre, que você pode mudar para Fixo no próximo passo.',
  chooseNeedsMediaSpend: 'Requer dados de investimento em mídia no relatório do modelo',
  chooseNeedsBudgetPropagation: 'Requer dados de propagação de orçamento no relatório do modelo',
  loading: 'Carregando simulações de orçamento...',
  noSimulations: 'Ainda não há simulações de orçamento',
  search: 'Buscar',
  ready: 'Pronta',
  running: 'Calculando... {done}/{total}',
  headerName: 'Nome',
  headerMixMode: 'Modo do Mix',
  headerPeriod: 'Período',
  headerProgress: 'Status',
  headerCreated: 'Criada',
  copy: 'cópia',
  gridRange: '{from}%–{to}% · {count} orçamentos',
  headerReferenceBudget: 'Orçamento de Referência ({unit})',
  sharedWithExternalUsers: 'Compartilhada com usuários externos'
}
